var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5415 2.15553V8.20703H4.45817V2.15553L2.70155 3.91216L1.93563 3.14624L4.99984 0.0820312L8.06405 3.14624L7.29813 3.91216L5.5415 2.15553ZM0.666504 7.66536H1.74984V9.83203H8.24984V7.66536H9.33317V9.83203C9.33317 10.4279 8.84567 10.9154 8.24984 10.9154H1.74984C1.154 10.9154 0.666504 10.3937 0.666504 9.83203V7.66536Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.a4f71a3f6ac139ef10a5df6e7517a066.svg";
export { ForwardRef as ReactComponent };